<template>
	<card> 
		<ReFormPrinter 
			:masFormConfig="masAllFormParams" 
			:objSaveApiMethod="currentApiFormMethod"		
			:SuccessGo="SuccessGo"/>
	</card>
</template>
<script>
import ReFormPrinter from 'src/our_components/FormPrinter/ReFormPrinter.vue';
export default {
	name: 'bp_editor_check_list-page',
	components: {
		ReFormPrinter,
	},
	data() {
	    return {
			currentApiFormMethod: this.currentApiFormMethodM(),
			masAllFormParams: this.currentFormConfig(),
		};
    },
	methods: {
		currentApiFormMethodM(){
			return {apiMethod:'UPD_CHECKLIST',apiParam:{obj:'BP' ,flt:{bp_id:this.$route.params.bp_id},uData:[]}};
		},
		currentFormConfig(){
			let bp_id = typeof this.$route.params.bp_id == 'undefined'?'':this.$route.params.bp_id;
			this.$GVO.ApiCall('GET_FORM_BP_CHECKLIST',{obj:'BP',flt:{'bp_id':bp_id}})
				.then((objApi) => {
					if(objApi.success === true){
						this.masAllFormParams = objApi.config;
					}
				}).catch(errorObjApi => console.error(errorObjApi));
			return [];
		},
		SuccessGo(evt){
			this.$router.go(-1);
		},

	},
	mounted() {

	}
};
</script>
<style>
</style>
